<template>
  <login-layout :title="$t('Scegli a quale pannello di controllo vuoi accedere.')">
    <x-form
      v-if="aziendeState.state === 'success'"
      :disabled="sending"
      :prevent-submit="!id_azienda"
      :submit-text="$t('Accedi')"
      submit-block
      @submit="submit"
    >
      <form-group :name="$t('Azienda')" no-label>
        <pf-form-select :aria-label="$t('Azienda')" :model-value="id_azienda" @update:model-value="id_azienda = String($event)" required>
          <pf-form-select-option v-for="az in sortedAziende" :key="az.id" :value="az.id">{{ az.azienda }}</pf-form-select-option>
        </pf-form-select>
      </form-group>
    </x-form>

    <pf-spinner v-else />

    <template #forgot-credentials>
      <pf-button variant="link" @click="app.logout()">{{ $t('Logout') }}</pf-button>
    </template>
  </login-layout>
</template>

<script lang="ts" setup>
import { http } from '../../http';
import { asyncComputed } from '@common/asyncComputed';
import { loginDestination } from '../../utils';
import LoginLayout from '../../components/login-layout.vue';
import { computed, ref, watch, type Ref } from 'vue';
import { useLoginStore } from '@/store/login';
import { useAppStore } from '@/store/app';
import { CompanyAccessResource, type CompanyAccess } from '@/resources';
import { useFunctionRunningState } from '@common/use';
import { useRoute, useRouter } from 'vue-router';

defineOptions({
  name: 'LoginAziendaPage',
});

const route = useRoute();
const router = useRouter();

const app = useAppStore();
const { result: aziende, state: aziendeState } = asyncComputed(() => new CompanyAccessResource().get(), {} as Record<number, CompanyAccess>);

const sortedAziende = computed(() => {
  const sorted = [];
  for(const[id, azienda] of Object.entries(aziende.value).sort(([ ,a], [, b]) => a.azienda.localeCompare(b.azienda))) {
    sorted.push({...azienda, id});
  }
  return sorted;
});

const id_azienda: Ref<string | null> = ref(null);

watch(aziende, () => {
  const ids = Object.keys(aziende.value);
  id_azienda.value = ids[0] ?? null;
});

const { isRunning: sending, run: submit } = useFunctionRunningState(async() => {
  if (!id_azienda.value) {
    return;
  }

  const data = new FormData();
  data.append('id_azienda', id_azienda.value);

  const result = (await http.post('/api/auth/companylogin', data)).data.result;

  if (result == 'ok') {
    const login = useLoginStore();
    await login.refresh();
    router.push(loginDestination(route.query));
  }
}, { preventMultiple: true });
</script>
